import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { TekinputService } from '../../service/tekinput.service';

@Component({
  selector: 'tekinput',
  templateUrl: './tekinput.component.html',
  styleUrls: ['./tekinput.component.scss'],
})
export class TekinputComponent {
  @Input() validated = false;
  @Input() disabled = false;
  @Input() correctValue = '';
  @Input() superior = false;
  @Input() inferior = false;
  @Input() value = '';
  @Input() isTeacher = true;
  @Input() controlName = '';
  @Input() tekInputType = '';
  @Input() length = 10;
  @Input() isCorrect = false;
  @Input() order = 0;
  @Input() options = '';
  @Input() isSelfCorrecting = true;
  @Input() isTry = false;
  @ViewChild('answer') inputText: ElementRef;
  private oldInputValue = '';

  constructor(private readonly tekInputService: TekinputService) {}

  checkValue(value: string) {
    this.isCorrect = this.normalizeValue(this.correctValue) === this.normalizeValue(value);
  }

  normalizeValue(value: string): string {
    if (this.tekInputType === 'number') {
      return parseFloat(
        value
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[.,]/g, '.')
          .replace(/\s/g, '')
          .replace(/^(\u2212|\u2013|\u2013|\u002D|\u2010|\u2014)/, '-')
          .replace(/\\+/, '')
          .replace(/^\+/, '')
      )
        .toFixed(5)
        .toString();
    } else {
      return value
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '')
        .replace(/^(\u2212|\u2013|\u2013|\u002D|\u2010|\u2014)/, '-');
    }
  }

  normalizeInput(value: string): string {
    if (this.tekInputType === 'number' && this.inputText) {
      value = value.replace(/^(\u2212|\u2013|\u2013|\u002D|\u2010|\u2014)/, '-');
      const regexp = new RegExp(/^(?:[-+]\d{0})?\d{0,3}(?:[ ]?\d{1})*(?:[, .]\d{0,})?$/g);
      const result = regexp.test(value);
      if (result) {
        this.inputText.nativeElement.value = value;
        this.oldInputValue = value;
      } else {
        this.inputText.nativeElement.value = this.inputText.nativeElement.value.length > 0 ? this.oldInputValue : '';
      }
      return this.inputText.nativeElement.value;
    } else {
      return value;
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: any) {
    this.tekInputService.setIsEditingInput(true);
    if (event.target.tagName.toLowerCase() === 'input') {
      switch (event.code) {
        case 'ArrowUp':
          event.preventDefault();
          window.scrollTo({ top: scrollY - 40, behavior: 'smooth' });
          break;
        case 'ArrowDown':
          event.preventDefault();
          window.scrollTo({ top: scrollY + 40, behavior: 'smooth' });
          break;
        default:
          break;
      }
    }
  }
}
